import { Route, Navigate } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { GlobalLoader } from './newcomponents/GlobalLoader/GlobalLoader';
import FetchLocalStorageDataByPath from './utils/helper/FetchLocalstorageDataByPath.js';
import UserContext from './components/UserContext/UserContext.js';
import { fixedPermissions } from './utils/helper/permissionFinder.js';

const AdminRoute = ({ component: Component, element, ...rest }) => {
  const [isFeatureActive, setisFeatureActive] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userPermissions, setUserPermissions } = useContext(UserContext);
  const auth = useAuth();
  const findPermissions = async () => {
    let x = sessionStorage.getItem('permissions') !== 'undefined' ? JSON.parse(sessionStorage.getItem('permissions')) : [];
    let obj = {};
    if (x !== undefined && x.length > 0) {
      await x.map((i) => {
        if (fixedPermissions.includes(i) === true) {
          obj[i] = true;
        }
        return null;
      });

      setUserPermissions(obj);
    }
  };

  useEffect(() => {
    findPermissions();
  }, []);
  const { path } = rest;
  const newPath = path.substr(1);

  const isAuthenticated = () => {
    const token = sessionStorage.getItem('authorizationToken');
    return token && token !== null;
  };

  useEffect(() => {
    getLocalStorageDataFunc();
  }, [path]);

  const userRole =
    userPermissions['Administrator_Panel'] === true;

  const getLocalStorageDataFunc = async () => {
    try {
      const fetchedLocalStorageData = FetchLocalStorageDataByPath('system_config', 'features') ?? [];
      const crudsPermissions = FetchLocalStorageDataByPath('system_config', 'adminPanel');
      const crudsPermissionsFound = await crudsPermissions.find((values) => values.path_name === newPath);
      const foundFeature = await fetchedLocalStorageData.find((values) => values.path_name === newPath);

      if (foundFeature) {
        setisFeatureActive((prev) => ({
          ...prev,
          [newPath]: foundFeature.value,
        }));
      } else if (crudsPermissionsFound) {
        setisFeatureActive((prev) => ({
          ...prev,
          [newPath]: crudsPermissionsFound.value,
        }));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  if (auth?.isLoading || auth?.activeNavigator) {
    return <GlobalLoader />;
  }

  if (auth?.isAuthenticated && !sessionStorage.getItem('authorizationToken')) {
    return <GlobalLoader />;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <GlobalLoader />;
  }

  if (isFeatureActive === null || !isFeatureActive.hasOwnProperty(newPath)) {
    return element;
  }

  if (isFeatureActive['systemconfiguration'] === false) {
    return <Navigate to={'/inbasketpage'} />;
  }

  if (isFeatureActive[newPath] === true || newPath === 'admin') {
    return element;
  }

  return <Navigate to={'/inbasketpage'} />;

  // return (
  //   <Route
  //     {...rest}
  //     render={(props) =>
  //       oktaTokenVal === true ? (
  //         isFeatureActive === null ? (
  //           <Redirect to={'/login'} />
  //         ) : isFeatureActive.hasOwnProperty(newPath) ? (
  //           isFeatureActive[newPath] === true ? (
  //             <Component {...props} />
  //           ) : (
  //             <Redirect to={'/inbasketpage'} />
  //           )
  //         ) : (
  //           <Component {...props} />
  //         )
  //       ) : (
  //         <Redirect to={'/login'} />
  //       )
  //     }
  //   />
  // );
};

export default AdminRoute;
